import React from 'react';
import ActionButtonsGroup from '../../../components/action_buttons_group/ActionButtonsGroup';

export const customTableColumns = (onEdit, onDelete, onShowResults, onStartSurvey) => [
  {
    Header: "Nombre",
    accessor: "name",
  },
  {
    Header: "Tipo de encuesta",
    accessor: "survey_type",
  },
  {
    id: "customButtons",
    Header: "Acciones",
    Filter: "",
    Cell: ({ row }) => {
      const { original } = row;
      const buttons = [
        {
          icon: 'edit',
          name: 'edit',
          id: 'edit',
          func: () => onEdit(original.id),
          text: '',
          variant: 'link'
        },
        {
          icon: 'computer',
          name: 'Resultados',
          id: 'results',
          func: () => onShowResults(original.id),
          text: '',
          variant: 'link'
        },
        {
          icon: 'start',
          name: 'Iniciar encuesta',
          id: 'surveyForm',
          func: () => onStartSurvey(original.id),
          text: '',
          variant: 'link'
        },
        {
          icon: 'close',
          name: 'delete',
          id: 'delete',
          func: () => onDelete(original.id),
          text: '',
          variant: 'link',
          className: 'text-danger'
        }
      ];
      return <ActionButtonsGroup buttons={buttons} />;
    },
  }
];
